import { useTranslation } from 'react-i18next';
import React from 'react';

interface IHistoryOfferHeaderProps {
    personalOffer?: string;
}

export function ContractHistoryOfferHeader({ personalOffer }: IHistoryOfferHeaderProps) {
    const { t } = useTranslation();
    if (!personalOffer) {
        return null;
    }
    return (
        <div className="mt-3">
            <h5>{t('influencer.offer_management.modal.add_personal_offer')}</h5>
            <p className="text-muted mb-0">{personalOffer}</p>
        </div>
    );
}
